import { makeStyles, type Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
	actions: {
		paddingTop: 16,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
	config: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		[theme.breakpoints.down('md')]: {
			'& span': {
				fontSize: 13,
			},
		},
	},
	questionsNumber: {
		display: 'flex',
		alignItems: 'center',
		'& p': {
			cursor: 'pointer',
		},
		[theme.breakpoints.down('md')]: {
			'& p': {
				fontSize: 13,
			},
		},
	},
}));

export default useStyles;
